<template>
  <div>
    <pdf
      :src="base64"
     :page="page"
     style="width: 100%"
     @error="errorPDF"
    />
    <v-layout wrap>
      <v-flex xs12
	v-if="numPages > 1"
      >
	<center>
	  <table :style="{ 'background-color': BGColor }">
	    <tr>
	      <td>
		<v-btn
		  text
		  :disabled="!page || page === 1"
		  @click="handleChangePage(-1)"
		>
		  <span :style="{ 'color': Color }">
		    <
		  </span>
		</v-btn>
	      </td>
	      <td>
		<span :style="{ 'color': Color }">
		  {{ page }} {{ $t('common.of', locale).toLowerCase() }} {{numPages}}
		</span>
	      </td>
	      <td>
		<v-btn
		  text
		  :disabled="page >= numPages"
		  @click="handleChangePage(1)"
		>
		  <span :style="{ 'color': Color }">
		    >
		  </span>
		</v-btn>
	      </td>
	      <td>	
		<v-btn block :color="BGColor" @click="handleDownload">
		  <span :style="{ 'color': Color }"> {{ $t('common.download', locale) }} </span>
		</v-btn>
	      </td>
	    </tr>
	  </table>
	</center>
      </v-flex>
      <v-flex xs12 style="padding: 20px 0;"
	v-else
      >
	<v-btn block :color="BGColor" @click="handleDownload">
	  <span :style="{ 'color': Color }"> {{ $t('common.download', locale) }} </span>
	</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import pdf from 'vue-pdf'
  export default {
    components: {
      pdf
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      locale: {
        type: String,
        required: false,
        default: 'es'
      }
    },
    data () {
      return {
        loading: false,
        base64: null,
        numPages: null,
        page: 1
      }
    },
    computed: {
      ...mapState('app',['BGColor', 'Color', 'Font', 'FontSize']),
    },  
    mounted () {
      this.handleGetData()
//        let recaptchaScript = document.createElement('script')
//      recaptchaScript.setAttribute('src', 'https://botdescubre.hotelequia.com/Scripts/webchat/botchat-launcher.js?locale=es')
//      document.head.appendChild(recaptchaScript)
      let recaptchaScript = document.createElement('script')
//      recaptchaScript.setAttribute('src', 'https://botdescubre.hotelequia.com/Scripts/webchat/botchat-launcher.js?locale=es')
//      document.head.appendChild(recaptchaScript)
    },
    methods: {
      prepareUrl () {
        let router = ''

        if (!this.$session.get('dfilesResponse')) router = 'public/folders'
        else router = 'external/customers'

        let url = '' 
        url += `${process.env.VUE_APP_API_URL_DFILES}/${router}/PDF/${this.item.ID}/${this.locale}/blob`
        //url += `?token=${this.$session.get('dfilesResponse')}`
        if (!this.$session.get('dfilesResponse')) url += `?workspace=${this.dfileWorkspace}`
        else url += `?token=${this.$session.get('dfilesResponse')}`
        return url
      },
      handleDownload () {
        const linkSource = this.base64 
        const downloadLink = document.createElement("a")
        const fileName = "info.pdf"

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },
      handleGetData () {
        this.loading = true
        //axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/PDF/${this.item.ID}/${this.locale}/blob?token=${this.$session.get('dfilesResponse')}`)
        axios.get(this.prepareUrl())
          .then(response => {
            this.base64 = `data:application/pdf;base64,${response.data.data}`
            this.loadPDF(this.base64)
          })
          .finally(() => {
            this.loading = false
          })
      },
      errorPDF (v) {
        console.log(v)
      },
      loadPDF (v) {
        this.loading = true
        if (v) {
          this.src = pdf.createLoadingTask(`${v}`)
          const that = this
          this.src.then(pdf => {
            that.numPages = pdf.numPages
            that.page = 1
          })
        }
      },
      handleChangePage(v) {
	      this.page += v
      }
    }
  }
</script>
